
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-whatsapp-template-generator",
      function () {
        return require("private-next-pages/ai-whatsapp-template-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-whatsapp-template-generator"])
      });
    }
  